export default function normalizeMake(make?: string) {
  return (make ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
}
